import { useMemo } from 'react';
import usePersistStore from '../stores/persistStore';

const fontSizeMap = {
    small: '12px',
    medium: '13px',
    large: '14px'
};

const urlSizeMap = {
    small: '11px',
    medium: '11px',
    large: '12px'
};

const itemFavMrMap = {
    small: '12px',
    medium: '12px',
    large: '16px'
};

const paddingMap = {
    small: '6px 10px',
    medium: '6px 10px',
    large: '8px 12px'
};

const favIconSizeMap = {
    small: '16px',
    medium: '20px',
    large: '24px'
};

const favIconOuterMap = {
    small: '24px',
    medium: '28px',
    large: '32px'
};

const todoMap = {
    small: '20px',
    medium: '22px',
    large: '24px'
};

const todoRoundedMap = {
    small: '6px',
    medium: '8px',
    large: '8px'
};

const showUrlOrNotMap = {
    small: false,
    medium: true,
    large: true
};

const newNoteMtMap = {
    small: '7px',
    medium: '7px',
    large: '10px'
};

const newNoteHeightMap = {
    small: '33px',
    medium: '33px',
    large: '36px'
};

const noteAlarmPosMap = {
    small: { top: '-2px', left: '2px' },
    medium: { top: '-1px', left: '2px' },
    large: { top: '3px', left: '3px' }
};

const todoAlarmPosMap = {
    small: { left: '31px' },
    medium: { left: '33px' },
    large: { left: '34px' }
};

const activeGroupMyMap = {
    small: '3px',
    medium: '4px',
    large: '6px'
};

export const useItemSize = () => {
    let itemSize = usePersistStore((state) => state?.itemSize);

    if (
        !fontSizeMap.hasOwnProperty(itemSize) ||
        !paddingMap.hasOwnProperty(itemSize)
    ) {
        console.error(`Invalid itemSize: ${itemSize}`);
        itemSize = 'large'; // Default to 'large' if itemSize is invalid
    }

    return useMemo(
        () => ({
            fontSize: fontSizeMap[itemSize],
            urlSize: urlSizeMap[itemSize],
            padding: paddingMap[itemSize],
            favIconSize: favIconSizeMap[itemSize],
            favIconOuterSize: favIconOuterMap[itemSize],
            todoSize: todoMap[itemSize],
            showUrlOrNot: showUrlOrNotMap[itemSize],
            newNoteMt: newNoteMtMap[itemSize],
            newNoteHeight: newNoteHeightMap[itemSize],
            todoRounded: todoRoundedMap[itemSize],
            itemFavMr: itemFavMrMap[itemSize],
            noteAlarmPos: noteAlarmPosMap[itemSize],
            todoAlarmPos: todoAlarmPosMap[itemSize],
            activeGroupMy: activeGroupMyMap[itemSize]
        }),
        [itemSize]
    );
};
